import { useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";
import { CalendarDays } from "lucide-react";

function monthMatrix(year, month) {
  const first = new Date(year, month, 1);
  const start = new Date(first);
  start.setDate(first.getDate() - first.getDay());
  const days = [];
  for (let i = 0; i < 42; i++) { const d = new Date(start); d.setDate(start.getDate() + i); days.push(d); }
  return days;
}
const iso = (d) => d.toISOString().slice(0, 10);

export default function CalendarPage() {
  const [acts, setActs] = useState([]);
  const [leads, setLeads] = useState([]);
  const [cursor, setCursor] = useState(new Date());

  useEffect(() => { api.activities().then(setActs); api.leads().then(setLeads); }, []);

  const byDate = useMemo(() => {
    const m = {};
    acts.forEach((a) => { const d = (a.date || a.created_at || "").slice(0, 10); if (!d) return; (m[d] ||= []).push({ t: a.action_type, kind: "act", status: a.status }); });
    leads.forEach((l) => { if (l.next_follow_up) { const d = l.next_follow_up.slice(0, 10); (m[d] ||= []).push({ t: `Follow up ${l.name}`, kind: "lead" }); } });
    return m;
  }, [acts, leads]);

  const y = cursor.getFullYear(), mo = cursor.getMonth();
  const cells = monthMatrix(y, mo);
  const todayIso = iso(new Date());

  return (
    <div className="space-y-6">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <div className="flex items-center gap-2 eyebrow text-[#D4AF37]"><CalendarDays className="w-4 h-4" /> Campaign Calendar</div>
          <h1 className="font-display text-3xl sm:text-4xl mt-1">{cursor.toLocaleString("default", { month: "long" })} {y}</h1>
        </div>
        <div className="flex gap-2">
          <button onClick={() => setCursor(new Date(y, mo - 1, 1))} className="px-3 py-2 rounded-lg border border-[#2A3042] text-sm text-[#94A3B8]">‹</button>
          <button onClick={() => setCursor(new Date())} className="px-3 py-2 rounded-lg border border-[#2A3042] text-sm text-[#94A3B8]">Today</button>
          <button onClick={() => setCursor(new Date(y, mo + 1, 1))} className="px-3 py-2 rounded-lg border border-[#2A3042] text-sm text-[#94A3B8]">›</button>
        </div>
      </div>

      <div className="card-lux p-4">
        <div className="grid grid-cols-7 gap-1 text-center text-xs text-[#64748B] uppercase tracking-wider mb-2">
          {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((d) => <div key={d}>{d}</div>)}
        </div>
        <div className="grid grid-cols-7 gap-1">
          {cells.map((d, i) => {
            const di = iso(d); const items = byDate[di] || []; const dim = d.getMonth() !== mo;
            return (
              <div key={i} className={`min-h-[90px] rounded-lg border p-1.5 ${di === todayIso ? "border-[#D4AF37]" : "border-[#2A3042]/60"} ${dim ? "opacity-35" : ""}`}>
                <div className="text-xs text-[#94A3B8] mb-1">{d.getDate()}</div>
                <div className="space-y-1">
                  {items.slice(0, 3).map((it, j) => (
                    <div key={j} className={`text-[10px] px-1.5 py-0.5 rounded truncate ${it.kind === "lead" ? "bg-[#F59E0B]/20 text-[#F59E0B]" : "bg-[#222736] text-[#F3E5AB]"}`}>{it.t}</div>
                  ))}
                  {items.length > 3 && <div className="text-[10px] text-[#64748B]">+{items.length - 3} more</div>}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
